import { render, staticRenderFns } from "./ClientCardImportModal.vue?vue&type=template&id=577c2ca2&scoped=true&"
import script from "./ClientCardImportModal.vue?vue&type=script&lang=js&"
export * from "./ClientCardImportModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientCardImportModal.vue?vue&type=style&index=0&id=577c2ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577c2ca2",
  null
  
)

export default component.exports